module.exports = new __parcel__URL__("../animals.a9e00e1d.png").toString();